<template>
  <el-dialog title="重设密码" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false">
    <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm"  label-width="100px" class="password-form">
      <!-- 原密码 -->
      <el-form-item v-show="!oldPasswordShow" class="form-password" label="原密码" prop="oldPassword">
        <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码" />
        <img src="../../../assets/images/password-show.png" @click="handlePassword('oldPasswordShow')" />
      </el-form-item>
      <el-form-item v-show="oldPasswordShow" class="form-password" label="原密码" prop="oldPassword">
        <el-input v-model="passwordForm.oldPassword" type="text" placeholder="请输入原密码" />
        <img src="../../../assets/images/password-hidden.png" @click="handlePassword('oldPasswordShow')" />
      </el-form-item>

      <!-- 新密码 -->
      <el-form-item v-show="!newPasswordShow" class="form-password" label="新密码" prop="newPassword">
        <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" />
        <img src="../../../assets/images/password-show.png" @click="handlePassword('newPasswordShow')" />
      </el-form-item>
      <el-form-item v-show="newPasswordShow" class="form-password" label="新密码" prop="newPassword">
        <el-input v-model="passwordForm.newPassword" type="text" placeholder="请输入新密码" />
        <img src="../../../assets/images/password-hidden.png" @click="handlePassword('newPasswordShow')" />
      </el-form-item>

      <!-- 确认密码 -->
      <el-form-item v-show="!confirmPasswordShow" class="form-password" label="确认密码" prop="confirmPassword">
        <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请输入确认密码" />
        <img src="../../../assets/images/password-show.png" @click="handlePassword('confirmPasswordShow')" />
      </el-form-item>
      <el-form-item v-show="confirmPasswordShow" class="form-password" label="确认密码" prop="confirmPassword">
        <el-input v-model="passwordForm.confirmPassword" type="text" placeholder="请输入确认密码" />
        <img src="../../../assets/images/password-hidden.png" @click="handlePassword('confirmPasswordShow')" />
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button class="btn-orange-plain" @click="updatePassword">确 定</el-button>
      <el-button class="btn-grey" @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import formValidators from '@/utils/formValidators'
import userApi from '@/api/user'
import { cryptoUtils } from '@/utils/common'
export default {
  name: 'reset-password',
  data () {
    const validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'change' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'change' },
          { validator: formValidators.checkPasswordSolid, trigger: 'change' }
        ],
        confirmPassword: [
          { validator: validateConfirmPass, trigger: 'change' }
        ]
      },
      formLoading: false,
      oldPasswordShow: false,
      newPasswordShow: false,
      confirmPasswordShow: false
    }
  },
  methods: {
    show () {
      this.dialogVisible = true
      this.oldPasswordShow = false
      this.newPasswordShow = false
      this.confirmPasswordShow = false
      this.$nextTick(() => {
        this.$refs.passwordForm.resetFields()
      })
    },
    updatePassword () {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          const payload = {
            oldPassword: cryptoUtils.AESEncrypt(this.passwordForm.oldPassword),
            newPassword: cryptoUtils.AESEncrypt(this.passwordForm.newPassword)
          }
          userApi.resetClientPassword(payload).then(res => {
            if (res.data.resultCode === '0') {
              this.dialogVisible = false
              this.$alert('密码修改成功,请重新登录', '提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  if (action === 'confirm') {
                    this.$store.commit('CLEAR_AUTH_INFO')
                    setTimeout(() => {
                      location.replace('/login')
                    }, 200)
                  }
                }
              })
            }
          })
        }
      })
    },
    handlePassword (val) {
      this[val] = !this[val]
    }
  }
}
</script>

<style lang="scss" scoped>
.form-password {
  position: relative;
  img {
    width: 22px;
    height: 22px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
}
</style>
